import React, { useState, useRef, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
// @redux
import { connect, useSelector } from 'react-redux';
// @material-ui
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Box, Card, CardContent, Modal, Button, Typography } from '@material-ui/core';

// @third-party
import clsx from 'clsx';
import Markdown from 'react-markdown'
import axios from 'axios';
import { v4 as uuid } from 'uuid';  


const useStyles = makeStyles((theme) => ({
    root: {
        height: 'auto',
        width: '100%',
        maxWidth: '80%',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        padding: '16px',
        borderRadius: '8px',
        backgroundColor: theme.palette.colors.fillStroke[400],
    },
    title: {
        padding: '16px',
        textAlign: 'center',
        //backgroundColor: theme.palette.primary.main,
        color: 'white',
        margin: 0,
        borderRadius: '8px',
        border: '1px solid ' + theme.palette.primary.dark,
    },
    cardContent: {
        padding: '16px',
    },
    container: {
        height: '70vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        //backgroundColor: '#f5f5f5',
    },
    chatContainer: {
        flex: 1,
        overflowY: 'auto',
        padding: '16px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    messageBubble: {
        maxWidth: '70%',
        padding: '12px 16px',
        borderRadius: '18px',
        wordWrap: 'break-word',
        position: 'relative',
        '& p': {
            margin: 0,
        },
    },
    userBubble: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        alignSelf: 'flex-end',
        borderBottomRightRadius: '4px',
    },
    assistantBubble: {
        backgroundColor: 'white',
        color: '#333',
        alignSelf: 'flex-start',
        borderBottomLeftRadius: '4px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    },
    messageLabel: {
        fontSize: '12px',
        fontWeight: 'bold',
        marginBottom: '4px',
        opacity: 0.8,
    },
    assistantLabel: {
        color: '#000',
    },
    conversationTitle: {
        textAlign: 'center',
        marginBottom: '16px',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    inputContainer: {
        display: 'flex',
        gap: '12px',
        alignItems: 'flex-end',
        padding: '16px 0',
        //backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid ' + theme.palette.primary.dark,
        padding: '16px',
        //boxShadow: '0 -2px 8px rgb(78, 77, 77)',
    },
    inputField: {
        flex: 1,
        /*backgroundColor: theme.palette.primary.dark,
        '& .MuiOutlinedInput-root': {
            borderRadius: '20px',
            backgroundColor: '#f8f9fa',
        },*/
    },
    sendButton: {
        minWidth: '48px',
        height: '48px',
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    label: {
        fontSize: '14px',
        fontWeight: 'bold',
    },
    inputText: {
        fontSize: '14px',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const ChatTALI = () => {
    const classes = useStyles();
    const [comment, setComment] = useState('');
    const [sessionId, setSessionId] = useState(uuid());
    const [current_session_title, setCurrent_session_title] = useState('');
    const [history, setHistory] = useState([
        /*{ role: 'user', content: 'hola valero', order: 1 },
        { role: 'assistant', content: ' **Hola, ¿en qué puedo ayudarte hoy?**', order: 2 },
        { role: 'user', content: 'donde estudio', order: 3 },
        { role: 'assistant', content: '**en la universidad interamericana pará el desarrollo**', order: 4 },
        { role: 'user', content: 'cuantos semestres tengo', order: 5 },
        { role: 'assistant', content: '**tienes 6 semestres**', order: 6 },*/
    ]);
    const user = useSelector((state) => state.userReducer.user);
    const messagesEndRef = useRef(null);

    // Función para hacer scroll automático al final
    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Efecto para hacer scroll cuando cambie el historial
    useEffect(() => {
        scrollToBottom();
    }, [history]);

    // ¿Por qué la respuesta del assistant y el error ponen el +2 en el order?
    // El +2 se usaba porque history.length no se actualiza inmediatamente tras setHistory (por el mensaje del usuario).
    // Pero esto puede causar problemas si hay concurrencia o si el estado no se actualiza como se espera.
    // Lo correcto es calcular el order en función del último mensaje en el historial, o usar una función de actualización.

    const handleService = async () => {
        if (!comment.trim()) return;

        const currentComment = comment;
        setComment('');

        // Agregar mensaje del usuario al historial solo una vez
        const userMessage = {
            role: 'user',
            content: currentComment,
            order: history.length + 1
        };
        setHistory(prev => [...prev, userMessage]);
        
        // Scroll inmediato después de agregar el mensaje del usuario
        setTimeout(() => scrollToBottom(), 100);

        const URL = 'https://iprgg9g54g.execute-api.us-east-1.amazonaws.com/prod/message';
        try {
            const response = await axios.post(
                URL,
                {
                    "message": currentComment,
                    "session_id": sessionId,
                    "user_id": user.person_id.toString(), // TODO: tiene que ser en funcion de cuanod inicia un chat con el assistant
                    "agent_type": "openai",
                    "session_name": current_session_title,
                },
                {
                    headers: { 'x-api-key': '7KP9CUmnZW4dbg2dTZHaE3S3WIOaA8rF7yRPhhn9' }
                }
            );
            if(response.data.session_name){    
                setCurrent_session_title(response.data.session_name);
            }
            // Para asegurar el orden correcto, usamos una función de actualización
            setHistory(prev => {
                const lastOrder = prev.length > 0 ? prev[prev.length - 1].order : 0;
                const assistantMessage = {
                    role: 'assistant',
                    content: response.data.response,
                    order: lastOrder + 1
                };
                return [...prev, assistantMessage];
            });
        } catch (error) {
            setHistory(prev => {
                const lastOrder = prev.length > 0 ? prev[prev.length - 1].order : 0;
                const errorMessage = {
                    role: 'assistant',
                    content: "Ocurrió un error al obtener la respuesta.",
                    order: lastOrder + 1
                };
                return [...prev, errorMessage];
            });
            console.error(error);
        }
    }
    console.log(history);
    return (
        <Box className={classes.root}>
            {/* Title Card */}
            <Card>
                <Box component={'h1'} className={classes.title}>Asistente TALI</Box>
            </Card>
            
            {/* Chat Content Card */}
            <Card>
                <CardContent className={classes.cardContent}>
                    {/* Título de la conversación */}
                    <Typography variant="h3" className={classes.conversationTitle}>
                        {current_session_title}
                    </Typography>
                    <Box className={classes.container}>
                        {/* Chat Messages Container */}
                        <Box className={classes.chatContainer}>
                            {history
                                .slice()
                                .sort((a, b) => a.order - b.order)
                                .map((item) => (
                                    <Box
                                        key={item.order}
                                        className={`${classes.messageBubble} ${
                                            item.role === 'user' ? classes.userBubble : classes.assistantBubble
                                        }`}
                                    >
                                        <Typography variant="caption" className={ 
                                            clsx(classes.messageLabel, item.role === 'assistant' && classes.assistantLabel)}>
                                            {item.role === 'user' ? 'Tú' : 'Asistente TALI'}
                                        </Typography>
                                        {item.role === 'user' ? (
                                            <Typography variant="body1">{item.content}</Typography>
                                        ) : (
                                            <Markdown>{item.content}</Markdown>
                                        )}
                                    </Box>
                                ))}
                            {/* Elemento invisible para el autoscroll */}
                            <div ref={messagesEndRef} />
                        </Box>
                        
                        {/* Input Container */}
                        <Box className={classes.inputContainer}>
                            <TextField
                                id="comment"
                                placeholder="Escribe tu mensaje..."
                                fullWidth
                                multiline
                                maxRows={3}
                                className={classes.inputField}
                                value={comment || ''}
                                variant="outlined"
                                onChange={(e) => setComment(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        handleService();
                                    }
                                }}
                            />
                            <Button
                                variant="contained"
                                className={classes.sendButton}
                                onClick={handleService}
                                disabled={!comment.trim()}
                            >
                                Enviar
                            </Button>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ChatTALI);